import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { APIService } from './api.service';

export interface ListResult<T> {
  page: number;
  page_size: number;
  total_pages: number;
  total_elements: number;
  data: T[];
}

@EnableClassTelemetry()
@Injectable()
export abstract class SemantriaAPIService extends APIService {
  getBaseUrl() {
    const appConfig = (window as any).appConfig || {};
    if (appConfig.semantria && appConfig.semantria.url) {
      return appConfig.semantria.url;
    }
    return 'https://api5-preprod.semantria.com';
  }

  getBaseHeaders() {
    return {
      Authorization: this.getToken(),
    };
  }
}
